import styled from "styled-components";
import React, { useEffect } from "react";
import XrTextAv from '../../../components/XrTextAv.tsx';
import XrCardAv from '../../../components/XrCardAv.tsx';
import XrButtonAv from '../../../components/XrButtonAv.tsx';
import XrDataTable from "../../../components/XrDataTable.tsx";
import { toast } from "react-toastify";

const FormSearchRoom = (props) => {
  const selectRoom = (e, room) => {
    const newSelectedRooms = [...props.selectedRooms];
    const selectedRoomIndex = newSelectedRooms.findIndex(i => i.id === room.id);
    if (selectedRoomIndex >= 0) {
      newSelectedRooms.splice(selectedRoomIndex, 1);
    } else {
      newSelectedRooms.push(room);
    };
    props.setSelectedRooms(newSelectedRooms);
  }

  const isRoomSelected = (roomId) => {
    if (typeof roomId === 'undefined') return false;
    if (props.selectedRooms.find(r => r.id === roomId)) return true;
    return false;
  }

  const actionConfirmRoom = () => {
    if (props.selectedRooms.length === 0) {
      toast.error('Harus memilih setidaknya satu ruangan.');
      return;
    }
    const newRooms = [];
    props.selectedRooms.forEach(room => {
      const roomId = room.id;
      if (roomId) {
        newRooms.push({
          id_room: roomId,
          room_detail: room
        });
      }
    });
    props.setForm({ ...props.form, rooms: newRooms });
    props.setCurrentStep('03-peminjaman-inventaris');
  }

  const actionUpdateDate = () => {
    props.setCurrentStep('01-detail-kegiatan')
    props.setForm({
      ...props.form, rooms: [],
      start_date: '',
      end_date: ''
    });
  }

  useEffect(() => {

  }, [props.form.rooms])

  const renderRoomOptions = () => {
    if (props.roomOptions.length === 0) {
      return (
        <tr style={{ textAlign: 'center' }}>
          <td colSpan={3}>
            <p>Tidak ada ruangan yang tersedia</p>
            <XrButtonAv
              noBlock
              size='large'
              caption={`Ubah Tanggal`}
              disabled={props.isLoading}
              isLoading={props.isLoading}
              onClick={actionUpdateDate}
              style={{ marginTop: '5px' }}
            />
          </td>
        </tr>
      );
    }
    return props.roomOptions.map((room, index) => {
      return (
        <tr key={index}>
          <td>
            <input
              type="checkbox"
              checked={isRoomSelected(room.id)}
              onChange={(e) => selectRoom(e, room)}
              id={`checkbox-booking-room-${room.id}`}
            />
          </td>
          <td>
            <label htmlFor={`checkbox-booking-room-${room.id}`}>
              {room.room_name}
            </label>
          </td>
          <td>10 orang</td>
        </tr>
      );
    })
  }

  const renderRoomTable = () => {
    return (
      <React.Fragment>
        <XrDataTable style={{ marginBottom: '20px' }}>
          <div className="tablewrapper--title">
            Ruangan yang Tersedia
          </div>
          <div className="tablewrapper--table">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Nama</th>
                  <th>Kapasitas</th>
                </tr>
              </thead>
              <tbody>
                {renderRoomOptions()}
              </tbody>
            </table>
          </div>
        </XrDataTable>
        <XrButtonAv
          size='large'
          color='primary'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          onClick={actionConfirmRoom}
          caption={`Konfirmasi Ruangan`}
        />
      </React.Fragment>
    );
  }

  return (
    <FormSearchRoomWrapper>
      <XrCardAv>
        <div className="card--title requestBooking__toolbar">
          <XrTextAv tag='h2' variant='title'>
            Cari Ruangan
          </XrTextAv>
          <XrButtonAv
            noBlock
            size='large'
            caption={`Ubah Tanggal`}
            disabled={props.isLoading}
            isLoading={props.isLoading}
            onClick={actionUpdateDate}
          />
        </div>
        <div className="card--body">
          {renderRoomTable()}
        </div>
      </XrCardAv>
    </FormSearchRoomWrapper>
  )
}

const FormSearchRoomWrapper = styled.div`
`;

export default FormSearchRoom;